import { Article, ArticleResponse } from "../coworkerApiCalls/Article/ArticlesTypes";

const articleResponseToArticle = (article: ArticleResponse): Article => {
  return {
    id: article.id,
    title: article.title,
    content: article.content,
    image: article.image,
    creationDate: article.creationDate,
    modificationDate: article.modificationDate,
    startDate: article.startDate,
    endDate: article.endDate,
    spaceId: article.spaceId,
    categoryId: article.categoryId
  };
};

const articleResponsesToArticles = (articles: ArticleResponse[]): Article[] => {
  return articles.map((article: ArticleResponse): Article => articleResponseToArticle(article));
};

export { articleResponseToArticle, articleResponsesToArticles };